import { useGetUserMetricsQuery } from '@/affiliate-dashboard/graphql';
import { Button } from '@/components/base/button';
import { Loading } from '@/components/base/loading';
import { PageHeading } from '@/components/base/page-heading';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIntl } from 'react-intl';
import invariant from 'tiny-invariant';
import { TableWithFeatures } from '../../base/table-with-features';
import { defaultColumns } from './columns';
import { RequestCouponModal } from './request-coupon';

export function Coupons(): JSX.Element {
  const { t } = useTranslation();
  const intl = useIntl();
  const { data, loading } = useGetUserMetricsQuery();
  const columns = useMemo(() => defaultColumns(intl, { t }), [t, intl]);
  const [openRequestCoupon, setOpenRequestCoupon] = useState(false);

  if (loading) {
    return <Loading />;
  }
  invariant(data?.userMetrics?.couponCodes, 'Coupon codes are not available');
  const coupons = data?.userMetrics?.couponCodes;

  return (
    <div className="flex flex-col gap-5">
      <PageHeading subheading={t('affiliateDashboard.couponsInfo')}>
        {t('affiliateDashboard.trackingCoupons')}
      </PageHeading>
      <RequestCouponModal
        isOpen={openRequestCoupon}
        onOpenChange={setOpenRequestCoupon}
      >
        <Button className="h-full w-full justify-start truncate rounded-lg px-3 py-2.5 md:w-fit md:justify-center md:py-1.5">
          {t('affiliateDashboard.requestCouponButton')}
        </Button>
      </RequestCouponModal>
      <TableWithFeatures
        data={coupons}
        columns={columns}
        searchPlaceholder="Search commissions..."
      />
    </div>
  );
}
